import { useQuery } from '@tanstack/react-query';
import { superAdminDashboardService } from '../services/superAdminDashboard.service';
import { useCurrentUser } from '@/shared/hooks/useCurrentUser';

export function useSuperAdminDashboard() {
  const { user } = useCurrentUser();
  
  const query = useQuery({
    queryKey: ['super_admin_dashboard'],
    queryFn: async () => {
      const { data, error } = await superAdminDashboardService.getDashboardData();
      if (error) throw error;
      return data;
    },
    // Chấp nhận cả admin và super_admin để tránh lỗi không render được cho user đang login
    enabled: !!user && (user.roleCode === 'super_admin' || user.roleCode === 'admin'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch
  };
}
